import { Activity, Bell } from 'lucide-react'
import './landing.css'

const monitors = [
  { name: 'api.example.com', status: 'up' as const, uptime: '99.9%' },
  { name: 'app.example.com', status: 'up' as const, uptime: '100%' },
  { name: 'legacy.example.com', status: 'degraded' as const, uptime: '98.2%' },
]

function statusColor(status: 'up' | 'degraded' | 'down') {
  if (status === 'up') return 'bg-status-up'
  if (status === 'degraded') return 'bg-status-degraded'
  return 'bg-status-down'
}

function Sparkline({ variant }: { variant: 'up' | 'degraded' }) {
  const points =
    variant === 'up'
      ? '0,24 12,18 24,20 36,8 48,12 60,4 72,10'
      : '0,20 12,22 24,16 36,18 48,14 60,20 72,12'
  return (
    <svg viewBox="0 0 72 28" className="h-7 w-full opacity-70" aria-hidden>
      <polyline
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={variant === 'up' ? 'text-status-up' : 'text-status-degraded'}
        points={points}
      />
    </svg>
  )
}

export function LandingHeroVisual() {
  return (
    <div className="relative mx-auto w-full max-w-lg text-text-primary">
      <div
        className="pointer-events-none absolute -inset-8 rounded-full bg-accent/20 blur-3xl"
        aria-hidden
      />
      <div className="landing-float relative overflow-hidden rounded-2xl border border-border/80 bg-surface/90 p-4 shadow-2xl shadow-black/40 backdrop-blur-md sm:p-5">
        <div className="mb-4 flex items-center justify-between border-b border-border-subtle pb-3">
          <div className="flex items-center gap-2 text-sm font-medium text-text-primary">
            <Activity className="h-4 w-4 text-accent" aria-hidden />
            Status overview
          </div>
          <span className="flex items-center gap-1.5 rounded-full bg-banner-bg px-2.5 py-0.5 text-xs text-accent">
            <Bell className="h-3 w-3" aria-hidden />
            Slack ready
          </span>
        </div>

        <ul className="space-y-3">
          {monitors.map((monitor, i) => (
            <li
              key={monitor.name}
              className="rounded-xl border border-border-subtle bg-app-bg/60 px-3 py-3"
            >
              <div className="mb-2 flex items-center justify-between gap-2">
                <span className="truncate text-sm font-medium text-text-primary">
                  {monitor.name}
                </span>
                <span className="flex shrink-0 items-center gap-2">
                  <span
                    className={`landing-pulse-dot h-2 w-2 rounded-full ${statusColor(monitor.status)}`}
                    style={{ animationDelay: `${i * 0.4}s` }}
                  />
                  <span className="text-xs text-text-muted">{monitor.uptime}</span>
                </span>
              </div>
              <Sparkline variant={monitor.status === 'up' ? 'up' : 'degraded'} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
